import * as React from 'react';
import { connect } from 'react-redux';
import { provideLocalizationService, registerForLocalization } from '@progress/kendo-react-intl';
import { Field } from '@progress/kendo-react-form';
import { FormPage, ComboBox, YearPicker, NumericBox } from '../../../ui';
import { loadStudyPlanFormPage, saveStudyPlan, loadStudyPrograms } from '../actions/study-plan-form-page-actions';
import { withRouter } from '../../../components/withRouter';

class StudyPlanFormPage extends React.PureComponent {

  constructor() {
    super();
    this.handleValidate = this.handleValidate.bind(this);
    this.handleBreadcrumbItemClick = this.handleBreadcrumbItemClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  async componentDidMount() {
    if (this.props.params?.studyPlanId) {
      await this.props.loadStudyPlanFormPage({
        [this.props.copy ? 'targetStudyPlanId' : 'studyPlanId']: this.props.params.studyPlanId
      });
    }
  }

  render() {
    const localizationService = provideLocalizationService(this);
    return (
      <FormPage
        title={localizationService.toLanguageString('StudyPlan.studyPlan')}
        breadcrumbItems={[
          {
            id: 'study-plans',
            text: localizationService.toLanguageString('StudyPlan.studyPlans')
          },
          {
            id: 'study-plan',
            text: localizationService.toLanguageString('StudyPlan.studyPlan'),
            disabled: true
          }
        ]}
        onBreadcrumbItemClick={this.handleBreadcrumbItemClick}
        validationResult={this.props.validationResult}
        loading={this.props.loading}
        initialValues={this.props.studyPlan}
        localizationService={localizationService}
        onSubmit={this.handleSubmit}
        onCancel={this.handleCancel}
        validator={this.handleValidate}
        render={() => (
          <>
            <Field
              name='year'
              label={localizationService.toLanguageString('StudyPlan.year')}
              component={YearPicker}
              width='180px'
              disabled={!this.props.copy && this.props.studyPlanCycles?.length > 0}
            />
            <Field
              name='studyProgram'
              label={localizationService.toLanguageString('StudyPlan.studyProgram')}
              component={ComboBox}
              loading={this.props.studyProgramsLoading}
              data={this.props.studyPrograms}
              onFilter={this.props.loadStudyPrograms}
              textField='name'
              valueField='id'
              width='320px'
              disabled={this.props.copy || this.props.studyPlanCycles?.length > 0}
            />
            <Field
              name='optionalCredits'
              label={localizationService.toLanguageString('StudyPlan.optionalCredits')}
              component={NumericBox}
              min={0}
              defaultValue={0}
              width='180px'
            />
          </>
        )}
      />
    );
  }

  handleValidate(values, localizationService, validationResult, modified) {
    const errors = {};
    if (!values.year) {
      errors.year = localizationService.toLanguageString('validation.required');
    } else if (this.props.copy) {
      const now = new Date();
      const currentYear = new Date().getFullYear();
      const yearToValidateAgainst = now.getMonth() > 6 ? currentYear : currentYear - 1;
      if (values.year < yearToValidateAgainst) {
        errors.year = localizationService.toLanguageString('StudyPlan.cannotCopyToPast');
      }
    }
    if (!values.studyProgram) {
      errors.studyProgram = localizationService.toLanguageString('validation.required');
    }
    if (!modified.studyProgram && !modified.year) {
      if (validationResult?.errors?.studyProgramId) {
        errors.studyProgram = validationResult?.errors?.studyProgramId;
      }
      if (validationResult?.errors?.year) {
        errors.year = validationResult?.errors?.year;
      }
    }
    return errors;
  }

  handleBreadcrumbItemClick(e) {
    if (e.id === 'study-plans') {
      this.props.navigate('/study_plans');
    }
  }

  handleCancel() {
    this.props.navigate(-1);
  }

  handleSubmit(payload) {
    this.props.saveStudyPlan({ ...payload, targetStudyPlanId: this.props.copy ? this.props.params.studyPlanId : null });
  }
}

registerForLocalization(StudyPlanFormPage);

const mapStateToProps = state => ({
  loading: state.studyPlanFormPage.loading,
  studyPlan: state.studyPlanFormPage.studyPlan,
  studyPlanCycles: state.studyPlanFormPage.studyPlanCycles,
  studyPrograms: state.studyPlanFormPage.studyPrograms,
  studyProgramsLoading: state.studyPlanFormPage.studyProgramsLoading,
  validationResult: state.studyPlanFormPage.validationResult
});

const mapDispatchToProps = dispatch => ({
  loadStudyPlanFormPage: (payload) => dispatch(loadStudyPlanFormPage(payload)),
  saveStudyPlan: (payload) => dispatch(saveStudyPlan(payload)),
  loadStudyPrograms: (payload) => dispatch(loadStudyPrograms(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(StudyPlanFormPage));
